import ProductManager from '../..//layout/admin/ProductManager';

export default function Products() {
  return (
    <>
      <div className="flex-colomn gap-2">
        <ProductManager />
      </div>
    </>
  );
}
